import { h, Component } from "preact";

//import { getApiPath } from "../../../path";
import { getApiPath, localPath } from "../../../path";

import ResultList from "..";
import ResultListItem from "../result-list-item";

const FILTER_BY_LETTER = "filterByLetter";
const FILTER_BY_PHRASE = "filterByPhrase";
const FILTERED_DATA = "filteredData";
const FILTERED_DATA_BY_LETTER = "filteredDataByLetter";
const FILTERED_DATA_BY_PHRASE = "filteredDataByPhrase";
const ALL_DATA = "allData";

class LinkList extends Component {
  state = {
    data: [],
    allData: [],
    filteredData: [],
    filteredDataByLetter: [],
    filteredDataByPhrase: [],
    filterByLetter: false,
    filterByPhrase: false,
    dbLoaded: false,
  };

  componentDidMount() {
    const fetchPath = getApiPath(
      this.props.locale,
      this.props.database,
      this.props.dbType
    );

    fetch(fetchPath)
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          this.setState((previousState) => ({
            ...previousState,
            data: result.data,
            allData: result.data,
            dbLoaded: true,
          }));
        }
        this.props.onListLoaded();
      })
      .catch((error) => {
        console.error(
          `Something went wrong connecting to database ${this.props.database} in LinkList:`,
          error
        );
      });
  }

  /**
   * Resets data when forType becomes false
   * @param forType {FILTER_BY_LETTER | FILTER_BY_PHRASE} The type that became false
   */
  resetdata = (forType) => {
    this.setState((previousState) => {
      let filterByLetter = previousState.filterByLetter;
      let filterByPhrase = previousState.filterByPhrase;
      let dataKey = ALL_DATA;
      let unfiltered = true;
      let filteredData = previousState.filteredData;
      if (forType === FILTER_BY_LETTER) {
        filterByLetter = false;
        // If the filterByPhrase key is set, show data filtered by phrase
        if (previousState.filterByPhrase !== false) {
          dataKey = FILTERED_DATA_BY_PHRASE;
          unfiltered = false;
        }
      }
      if (forType === FILTER_BY_PHRASE) {
        filterByPhrase = false;
        // If the filterByLetter key is set, show data filtered by letter
        if (previousState.filterByLetter !== false) {
          dataKey = FILTERED_DATA_BY_LETTER;
          unfiltered = false;
        }
      }
      if (unfiltered) {
        filteredData = [];
      }
      return {
        ...previousState,
        data: previousState[dataKey],
        filterByLetter,
        filterByPhrase,
        filteredData,
      };
    });
  };

  /**
   * Only show data which starts with the selected letter
   * Triggered by selecting a letter from the alphabet
   * @param letter {string | false}
   */
  filterDataByLetter = (letter) => {
    if (letter !== false) {
      this.setState((previousState) => {
        const dataKey =
          previousState.filterByPhrase === false
            ? ALL_DATA
            : FILTERED_DATA_BY_PHRASE;
        const filteredDataByLetter = previousState[dataKey].filter(
          (item) =>
            item[this.props.filterKey][0].toLowerCase() === letter.toLowerCase()
        );
        return {
          ...previousState,
          data: filteredDataByLetter,
          filterByLetter: letter,
          filteredDataByLetter,
        };
      });
    } else {
      this.resetdata(FILTER_BY_LETTER);
    }
  };

  filterByPhrase = (phrase) => {
    if (phrase !== false) {
      const dataKey = !this.state.filterByLetter
        ? ALL_DATA
        : FILTERED_DATA_BY_LETTER;

      this.setState((previousState) => {
        const filteredDataByPhrase = previousState[dataKey].filter((item) => {
          const lineToTest = this.getLinkText(item, this.props.textKey);
          return lineToTest.toLowerCase().indexOf(phrase.toLowerCase()) !== -1;
        });
        return {
          ...previousState,
          data: filteredDataByPhrase,
          filterByPhrase: phrase,
          filteredDataByPhrase,
        };
      });
    } else {
      this.resetdata(FILTER_BY_PHRASE);
    }
  };

  componentWillReceiveProps({ filterByLetter, filterByPhrase }) {
    if (filterByLetter !== this.state.filterByLetter) {
      this.filterDataByLetter(filterByLetter);
    }
    if (filterByPhrase !== this.state.filterByPhrase) {
      this.filterByPhrase(filterByPhrase);
    }
  }

  getLinkText(item, textKey) {
    let linkText = "";
    if (Array.isArray(textKey)) {
      const linkTextArray = textKey.reduce((prev, curr) => {
        prev.push(item[curr]);
        return prev;
      }, []);
      linkText = linkTextArray.join(" ");
    } else {
      linkText = item[textKey];
    }
    return linkText;
  }

  render() {
    if (this.state.dbLoaded) {
      console.log("TEST8", this.props.resultLinkPath, this.props.locale);
      const cleanResultLinkPath = this.props.resultLinkPath.substring(3);
      return (
        <ResultList inColumns={true}>
          {this.state.data.map((item, index) => (
            <ResultListItem
              key={index}
              path={localPath(
                this.props.locale,
                `${cleanResultLinkPath}/${item[this.props.resultLinkPathIdKey]}`
              )}
            >
              {this.getLinkText(item, this.props.textKey)}
            </ResultListItem>
          ))}
        </ResultList>
      );
    }
  }
}

export default LinkList;
